import { render } from "./VabThemeSetting.vue?vue&type=template&id=2388a99a&scoped=true"
import script from "./VabThemeSetting.vue?vue&type=script&lang=js"
export * from "./VabThemeSetting.vue?vue&type=script&lang=js"

import "./VabThemeSetting.vue?vue&type=style&index=0&id=2388a99a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2388a99a"],['__file',"src/vab/components/VabTheme/components/VabThemeSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2388a99a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2388a99a', __exports__)) {
    console.log('reload')
    api.reload('2388a99a', __exports__)
  }
  
  module.hot.accept("./VabThemeSetting.vue?vue&type=template&id=2388a99a&scoped=true", () => {
    console.log('re-render')
    api.rerender('2388a99a', render)
  })

}


export default __exports__